import { render, staticRenderFns } from "./TireContractDetailPage.vue?vue&type=template&id=53223924&scoped=true"
import script from "./TireContractDetailPage.vue?vue&type=script&lang=ts"
export * from "./TireContractDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./TireContractDetailPage.vue?vue&type=style&index=0&id=53223924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53223924",
  null
  
)

export default component.exports